import { normalizeResolvedPath } from '../../paths/normalize-resolved-path.js';
import { registerSymbolIndexParentAsync } from '../symbol-index/build/ensure-symbol-index-file.js';
import { scheduleSymbolIndexWarmup } from '../symbol-index/scheduler/symbol-index-scheduler.js';

export function triggerSymbolIndexBuild(parentPath: string): void {
  setImmediate(() => {
    void (async () => {
      const resolved = normalizeResolvedPath(parentPath);
      await registerSymbolIndexParentAsync(resolved);
      scheduleSymbolIndexWarmup(resolved);
    })();
  });
}
